import React, {useEffect, useState} from "react";
import axios from "../utility/customAxios";
import {useSearchParams} from "react-router-dom";
import {SingleSelectorSearchableDropdown} from "./Input/SingleSelectorSearchableDropdown";
import {DropDownItem, stringArrayToDropDownItemArray} from "./Input/MultiSelectorDropdown/MultiSelectorDropDown";

export function ClusterSelector() {
    const [searchParams, setSearchParams] = useSearchParams();
    let params = new URLSearchParams(searchParams);
    const [clusters, setClusters] = useState<string[]>([])
    const [selectedCluster, setSelectedCluster] = useState<string>(params.get("environment") || "")
    const [clusterItems, setClusterItems] = useState<DropDownItem[]>([])
    const [selectedClusterItem, setSelectedClusterItem] = useState<DropDownItem>({
        displayName: selectedCluster === "" ? "All Environments" : selectedCluster,
        value: selectedCluster === "" ? "*" : selectedCluster
    })

    useEffect(() => {
        // Fetch environments/clusters
        axios.get("/api/v1/environments").then((response) => {
            setClusters(response.data.environments)

            // Sort environments alphabetically
            const sortedEnvironments = [...response.data.environments].sort((a, b) => a.localeCompare(b));

            // Create cluster items with custom wildcard item for "All Clusters"
            const items = stringArrayToDropDownItemArray(sortedEnvironments);

            // Add custom wildcard item at the beginning
            const allClustersItem: DropDownItem = {
                displayName: "All Environments",
                value: "*"
            };

            // Remove any existing wildcard items to avoid duplicates
            const filteredItems = items.filter(item => item.value !== "*");

            // Set cluster items with custom wildcard item at the beginning
            setClusterItems([allClustersItem, ...filteredItems]);
        }).catch((e) => {
            console.error(e)
        })
    }, [])

    useEffect(() => {
        let params = new URLSearchParams(searchParams);
        params.set("environment", selectedCluster);
        setSearchParams(params);
    }, [selectedCluster])

    // Update selectedCluster when selectedClusterItem changes
    const handleSelectedClusterChange = (item: DropDownItem) => {
        setSelectedClusterItem(item);
        // If wildcard (*) is selected, set selectedCluster to empty string for "All Clusters" functionality
        if (item.value === "*") {
            setSelectedCluster("");
        } else {
            setSelectedCluster(item.value);
        }
    }

    return (
        <div className={"flex h-[24px]"}>
            <div className={"border border-emerald-400 bg-secondarytransparenter px-2 rounded-l text-textlight font-medium"}> Environment </div>
            <SingleSelectorSearchableDropdown
                noMatchString={"No environments found"}
                possibleItems={clusterItems}
                searchPlaceholder={"Search environment..."}
                selected={selectedClusterItem}
                setSelected={handleSelectedClusterChange}
                displaySettings={{
                    smallSize: false,
                    borderClassName: "border-r border-t border-b",
                    className: "text-sm rounded-r"
                }}
            />
        </div>

    )
}
